/* MessageBox.tsx
   Version: 1.1.0
   Date: 2020-12-12
*/

// eslint-disable-next-line
import React from 'react';
import Modal from './Modal';
import Icon from './Icon';
import Text from './Text';
import Button from './Button';

export interface MessageBoxProps {
    text: string;
    onClick: () => void;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface MessageBoxState { }

export default class MessageBox extends React.Component<MessageBoxProps, MessageBoxState> {

    private button: HTMLInputElement | undefined = undefined;

    public render  = (): JSX.Element => {

        return(
            <Modal>
                <div className="modal-message">
                    <div className="modal-message-box">
                        <div className='modal-message-box-left'>
                            <Icon className='modal-message-box-icon' url={`${process.env.PUBLIC_URL}/image/help-hint.svg`} />
                        </div>
                        <div className='modal-message-box-right'>
                            <div className='modal-message-box-top'>
                                <Text className=''>{this.props.text}</Text>
                            </div>
                            <div className='modal-message-box-bottom'>
                                <Button name='message' value='OK' refFunc={ (btn): void => { this.button = btn; } } onClick={this.props.onClick} />
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    
    }

    public componentDidMount = (): void => {

        if (this.button) {
            this.button.focus();
        }

    }

}
